import { StateUpdater, useEffect, useState } from 'preact/hooks';

interface BodyStyles {
  overflow?: string;
}

export const useBodyScrolling = (): { setBodyScrolling: StateUpdater<boolean> } => {
  const [bodyScrolling, setBodyScrolling] = useState(true);
  const [originalBodyStyles, setOriginalBodyStyles] = useState<BodyStyles | null>(null);

  useEffect(() => {
    if (document.body) {
      setOriginalBodyStyles({
        overflow: document.body.style.overflow,
      });
    }
  }, []);

  useEffect(() => {
    if (!document.body) {
      return;
    }

    if (!bodyScrolling) {
      document.body.style.overflow = 'hidden';

      return;
    }

    if (originalBodyStyles?.overflow) {
      document.body.style.overflow = originalBodyStyles.overflow;

      return;
    }
    document.body.style.removeProperty('overflow');
  }, [bodyScrolling, originalBodyStyles]);

  return { setBodyScrolling };
};
